<template>
  <div>
    <el-upload
      class="single-uploader"
      :action="uploadIp + '/job/uploadImages'"
      :auto-upload="false"
      :show-file-list="false"
      :headers="headers"
      :on-change="handleChange"
      :before-upload="beforeSingleUpload">
      <img v-if="imageUrl" :src="imageUrl" class="single">
      <i v-else class="el-icon-plus single-uploader-icon"></i>
    </el-upload>
    <el-dialog
      title="图片剪裁"
      width="800px"
      height="600px"
      class="cropper_dialog"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center;height: 400px;">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false"><i class="iconfont iconcancel01"></i> 取 消</el-button>
        <el-button type="primary" @click="finish"><i class="iconfont iconok01"></i> 确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/utils/index'
import { uploadPhoto } from '@/api/exam'
export default {
  name: 'PhotoUpload',
  props: {
    data: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      dialogVisible:false,
      option: {
        img: "", // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 300, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [200, 300], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      uploadIp: config.uploadIp,
      imgIp: config.imgIp,
      imageUrl: ''
    }
  },
  computed: {
    headers() {
      return {
        Authorization: this.$store.state.user.token
      }
    }
  },
  mounted() {
    if (this.data) {
      this.imageUrl = this.imgIp + this.data
    }
  },
  methods: {
    handleChange(file) {
      console.log(file)
      let that = this
      let _file = file.raw;
      let reader = new FileReader();
      reader.readAsDataURL(_file);
      reader.onload = function (e) {
        let image = new Image();
        image.src = e.target.result;
        that.option.img = image.src;
        that.dialogVisible = true;
      };
      // this.imageUrl = URL.createObjectURL(file.raw);
      // this.$emit('uploadSuccess', res.data.imageId)
    },
    beforeSingleUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false
      }
      let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (fileType.toLowerCase() === 'png' || fileType.toLowerCase() === 'jpg' || fileType.toLowerCase() === 'jpeg') {
        return true
      } else {
        this.$message.error('上传图片格式只支持png,jpg,jpeg格式');
        return false
      }
    },
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob((data) => {
        let file = new File([data], new Date().getTime() + ".jpeg", {
          lastModified: new Date(2018, 1, 1),
        });
        this.fileData = [[file]];
        let formData = new FormData()
        formData.append('file', file)
        uploadPhoto(formData)
          .then((res) => {
            console.log(res)
            if (res.code === 200) {
              that.$emit('uploadSuccess', res.data.imageId)
              that.imageUrl = URL.createObjectURL(file)
              that.dialogVisible = false
              that.option.img = '';
            }
          })
      });
    }
  }
}
</script>

<style lang="scss">
.single-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409EFF;
    }
  }
  .single-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 78px;
    height: 78px;
    line-height: 78px;
    text-align: center;
  }
  .single {
    width: 78px;
    height: 78px;
    display: block;
  }
}
</style>
